import { bs } from './bs';
import { en } from './en';
import { hr } from './hr';
import { sr } from './sr';

export type Language = 'en' | 'sr' | 'bs' | 'hr';

export const languages: Record<Language, { name: string; nativeName: string }> = {
  en: { name: 'English', nativeName: 'English' },
  sr: { name: 'Serbian', nativeName: 'Srpski' },
  bs: { name: 'Bosnian', nativeName: 'Bosanski' },
  hr: { name: 'Croatian', nativeName: 'Hrvatski' },
};

export const translations = {
  en,
  sr,
  bs,
  hr,
} as const;

export type Translations = typeof en;
